import { required, url, decimal, requiredIf, helpers, } from 'vuelidate/lib/validators';

const greaterThanZero = (param) => helpers.withParams(
  { type: 'minValue', eq: param },
  (value) => value > 0
);

const validations = {
  code: {
    required,
  },
  // catalogNumber: { 
  //   required,
  // },
  title: {
    required,
  },
  // shortDescription: {
  //   required,
  // },
  // description: {
  //   required,
  // },
  nc: {
    // required,
    decimal,
  },
  vpc: {
    // required,
    decimal,
  },
  mpc: {
    // required,
    decimal,
  },
  // unitOfMeasureId: {
  //   required,
  // },
  // nettoWeight: {
  //   required,
  // },
  categoryIds: {
    required,
  },
  // companyId: {
  //   required,
  // },
  minOrderQuantity: {
    required: requiredIf(function() {
      return this.orderQuantityRatio;
    }),
    minValue: greaterThanZero('minOrderQuantity'),
    decimal,
  },
  // taxId: {
  //   required,
  // },
  videoUrl: {
    url,
  },
};

export default validations;